// extracted by mini-css-extract-plugin
export default {"container":"SignUp_container__iie1G","form":"SignUp_form__RcCc3","button":"SignUp_button__f0wIa","title":"SignUp_title__b779K"};